import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconShift: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} ariaLabel="shift" maskId="round-filled-radius-1-stroke-1.5-IconShift"><path d="M13.2507 2.45765C12.5641 1.75516 11.434 1.75516 10.7475 2.45765L2.37301 11.0269C1.29008 12.135 2.07519 14 3.62459 14H6.1175V19.25C6.1175 20.2165 6.90101 21 7.8675 21H16.1307C17.0972 21 17.8807 20.2165 17.8807 19.25V14H20.3736C21.923 14 22.7081 12.135 21.6252 11.0269L13.2507 2.45765Z" fill="currentColor"/></CentralIconBase>;
});

export default IconShift;
